module.exports = __webpack_public_path__ + "img/icon-share.c064578d.svg";